const BASE = '/api';

function token() { return localStorage.getItem('bau_token'); }
function headers(extra = {}) {
  return { 'Content-Type': 'application/json', ...(token() ? { Authorization: `Bearer ${token()}` } : {}), ...extra };
}

async function handle(res) {
  if (!res.ok) {
    let msg = `Fehler ${res.status}`;
    try { const d = await res.json(); msg = d.error || msg; } catch {}
    throw new Error(msg);
  }
  return res.json();
}

export const api = {
  get: (path) => fetch(`${BASE}${path}`, { headers: headers() }).then(handle),
  post: (path, body) => fetch(`${BASE}${path}`, { method: 'POST', headers: headers(), body: JSON.stringify(body) }).then(handle),
  put: (path, body) => fetch(`${BASE}${path}`, { method: 'PUT', headers: headers(), body: JSON.stringify(body) }).then(handle),
  delete: (path) => fetch(`${BASE}${path}`, { method: 'DELETE', headers: headers() }).then(handle),
  upload: (path, formData) => fetch(`${BASE}${path}`, {
    method: 'POST', headers: { ...(token() ? { Authorization: `Bearer ${token()}` } : {}) }, body: formData,
  }).then(handle),
  downloadUrl: (path) => `${BASE}${path}`,
};
